import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice';
import { getScreenAdminThunk, initialStatePage } from '../../store/slices/pages/page.slice';

const Navbar = React.lazy(() => import('./components/Navbar'));
const LastMinute = React.lazy(() => import('./components/LastMinute'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import MainLoader from '../../components/Loaders/MainLoader.jsx';
import { scrollToTop } from '../../utils/funtions.js';

const LastMinutePage = () => {

  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);
  const lastMinuteState = useSelector(state => state.page);
  const isLoading = useSelector(state => state.isLoadingSlice);

  useEffect(() => {
    scrollToTop();
    dispatch(getScreenAdminThunk('last-minute-deals'));
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStatePage());
    }
  }, []);

  return (
    <div className='bg-white'>
      <Helmet>
        <title>Last Minute Galapagos Cruise Deals – Rolf Wittmer Yachts</title>
        <meta name="description" content="Take advantage of exclusive last-minute offers for first-class Galapagos cruises. Limited cabins available – book now and save!" />
      </Helmet>
      {
        isLoading || yachtState.fetching || lastMinuteState.page?.sections === undefined ? <MainLoader /> :
          <>
            <Navbar yachtState={yachtState.yachts} />
            <LastMinute
              lastMinuteState={lastMinuteState.page}
              yachtState={yachtState.yachts}
            />
            <ContactUs />
            <Footer />
          </>
      }
    </div>
  );
};

export default LastMinutePage;